// Date recommendation column ids.
export const FACTOR_CODES = {
    hasShifts: 'hasShifts',
    distance: 'distanceScore',
    load: 'numIncompleteVisitsOnDateForBusiestClinician',
} as const;

// Recommended date column labels.
export const FACTOR_LABELS: Record<(typeof FACTOR_CODES)[keyof typeof FACTOR_CODES], string> = {
    [FACTOR_CODES.hasShifts]: 'Shift Availability',
    [FACTOR_CODES.distance]: 'Proximity to Visits',
    [FACTOR_CODES.load]: 'Daily Volume',
};
